import { useConsole } from "contexts/Console"
import useSSR from "hooks/useSSR"
import { createPortal } from "react-dom"
import styled from "@emotion/styled"
import { cssVars, useNav } from "components/nav-v2/Wrapper"
import { useLayoutEffect, useRef } from "react"
import { animate } from "framer-motion"
import { useMotionValueEvent } from "framer-motion"

const BackDrop = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, calc(var(${cssVars.overlay.opaque}) * 0.3));
  pointer-events: none;
  backdrop-filter: blur(calc(var(${cssVars.overlay.opaque}) * 5px));

  z-index: 9996;
`

const NavOverlay = props => {
  const console = useConsole()
  const ssr = useSSR()
  const nav = useNav()
  const rbackdrop = useRef(null)
  let _late

  useMotionValueEvent(nav.overlay.motion.opaque, "change", latest => {
    const previous = nav.overlay.motion.opaque.getPrevious()

    if (!previous || !latest || _late) {
      if (rbackdrop.current) rbackdrop.current.style.setProperty("pointer-events", latest > 0 ? "auto" : "none")
      else _late = true
    }
  })

  useLayoutEffect(() => {
    const controller = new AbortController()

    global.addEventListener(
      "keydown",
      e => {
        if (e.key === "Escape" && nav.overlay.motion.opaque.get() > 0 && !["INPUT", "TEXTAREA"].includes(e.currentTarget.tagName)) {
          nav.collapseAll()
        }
      },
      { signal: controller.signal }
    )

    return () => controller.abort()
  })

  console.verbose("Nav:Overlay(%o)", props)
  return !ssr && createPortal(<BackDrop onClick={nav.collapseAll} ref={rbackdrop} />, document.body)
}

export default NavOverlay
